export const environment = {
  production: true,
  version: require('../../package.json').version,
  apiBase: 'https://stage-api.poured.us/',
  loginUrl: 'https://stage-api.poured.us/login',
  whitelistedDomains: ['http://stage-api.poured.us/', 'https://stage-api.poured.us/', 'https://stage.poured.us/'],
  GoogleApiKey: 'AIzaSyAoaGqbbFjJlOQ1hgfEOEah_gX_Ljgl9SU',
  s3Bucket: 'stage-poured-api-attachment',
};



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/environments/environment.ts